import { setLocale } from "yup";

/*
 * Yup'ın varsayılan doğrulama mesajları İngilizce ("this is a required field",
 * "this must be a `number` type…"). Mesaj verilmeyen her validator bu
 * varsayılanı ekrana basıyordu (paket formu, kupon, duyuru, link oluşturma…).
 *
 * Tek seferlik Türkçe locale: uygulama girişinde (index.js) import edilir,
 * form bazında mesaj verilmiş alanları ETKİLEMEZ — yalnız mesajsız kalanların
 * varsayılanını değiştirir.
 */
setLocale({
    mixed: {
        required: "Bu alan zorunludur",
        notType: "Geçerli bir değer giriniz",
        oneOf: "Geçersiz seçim",
    },
    string: {
        email: "Geçerli bir e-posta adresi giriniz",
        min: "En az ${min} karakter olmalı",
        max: "En fazla ${max} karakter olabilir",
        url: "Geçerli bir adres giriniz",
    },
    number: {
        min: "En az ${min} olmalı",
        max: "En fazla ${max} olabilir",
        positive: "Sıfırdan büyük olmalı",
        integer: "Tam sayı olmalı",
    },
    date: {
        min: "Tarih ${min} veya sonrası olmalı",
        max: "Tarih ${max} veya öncesi olmalı",
    },
});
